<template>
  <div id="app" class="min-h-screen bg-white-bg md:bg-transparent">
    <div
      v-if="$route.query.env === 'dev'"
      class="w-full text-center text-xs sm:text-sm bg-yellow-100 text-yellow-900"
    >
      Versión de desarrollo
    </div>
    <router-view />
  </div>
</template>

<script>
import './main.css';
import { clients } from '@/config/clients';
import { useGlobalStore } from '@/stores/global';
import { startAppTimer } from '@/utils/metrics';

export default {
  name: 'App',
  async created() {
    const store = useGlobalStore();

    // Get clinicId from route query for landingConfig
    const clinicId = this.$route.query.clinicId;
    const landingConfig = await store.getLandingConfig(clinicId);

    const root = document.documentElement;
    if (landingConfig) {
      root.style.setProperty('--color-primary', landingConfig.primary_color);
      root.style.setProperty(
        '--color-secondary',
        landingConfig.secondary_color
      );
      root.style.setProperty('--color-tertiary', landingConfig.tertiary_color);

      // Store the landingConfig in the store for components to access
      store.landingConfig = landingConfig;
    } else {
      const colors =
        clients[document.documentElement.getAttribute('data-theme')]?.colors;

      root.style.setProperty('--color-primary', colors.primary);
      root.style.setProperty('--color-secondary', colors.secondary);
      root.style.setProperty('--color-tertiary', colors.tertiary);
    }

    const clientId = this.$route.query.clientId;
    const token = this.$route.query.token;
    const type = this.$route.query.type;
    const professionalId = this.$route.query.professionalId;

    await store.fetchState(clientId);
    const {
      shouldRedirect,
      clientId: redirectClientId,
      token: redirectToken,
      type: redirectType,
      professionalId: redirectProfessionalId,
    } = await store.checkQuestionnaireStatus(
      clientId,
      token,
      type,
      professionalId
    );

    if (shouldRedirect && this.$route.path !== '/') {
      this.$router.push({
        path: '/',
        query: {
          clientId: redirectClientId,
          token: redirectToken,
          type: redirectType,
          professionalId: redirectProfessionalId,
        },
      });
    }

    // Initialize app timer
    startAppTimer();
  },
};
</script>
